<template>
  <div class="tip-container" @click="handleClose">
    <div class="box" :style="currentStyle" @click.stop>
      <div class="info">恭喜您领取成功</div>
      <div class="content">
        <span class="tip">{{ data }}</span>
      </div>
      <van-button class="copy-btn" block type="primary" @click="handleCopy">
        复制
      </van-button>
      <van-icon
        class="close-icon"
        size="35"
        color="#f5f5f5"
        name="close"
        @click="handleClose"
      />
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { px2rem, copyText } from "@/utils/util";
import { Toast } from "vant";
// import Cookies from "js-cookie";

export default {
  props: {
    data: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checked: undefined,
      currentStyle: {
        width: px2rem(628),
        height: px2rem(400),
      },
    };
  },
  mounted() {
    // 获取屏幕高度和高度，如何宽度大于高度，图片高度需要小一点
    const width = window.innerWidth;
    const height = window.innerHeight;
    if (width > height) {
      this.currentStyle.width = "auto";
      this.currentStyle.height = "60%";
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleCopy() {
      copyText(this.data).then(() => {
        Toast("复制成功");
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tip-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  .box {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    position: relative;
    padding: 10px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    box-sizing: border-box;
    .info {
      font-size: 18px;
      color: #4b4b4b;
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      // height: 100%;
      padding: 10px 22px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid rgba(214, 187, 138, 0.42);
      box-sizing: border-box;
      .tip {
        font-weight: 400;
        font-size: 16px;
        color: #4b4b4b;
        line-height: 16px;
        word-break: break-all;
      }
    }
    .copy-btn {
      width: 200px;
    }
    .close-icon {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
